import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getSkuData = (state: RootState) => state.skus;

const getAllSkuData = createSelector([getSkuData], (skuData) => skuData);

export default getAllSkuData;
